import { getCookie, setWildCardCookie } from "~/utils/cookie-util";

const infoApi = "https://info.betwayafrica.com/api/v1.0";
export default defineNuxtPlugin(() => {
	return {
		provide: {
			initBannerTags: initBannerTags,
		},
	};
});

async function initBannerTags(): Promise<boolean> {
	return await SetTokens();
}

function SetTokens() {
	return new Promise(async (resolve, reject) => {
		try {
			let match;
			const pl = /\+/g;
			const search = /([^&=]+)=?([^&]*)/g;
			const decode = function (s: string) {
				return decodeURIComponent(s.replace(pl, " "));
			};
			const query = window.location.search.substring(1);
			const urlParams: { [x: string]: string } = {};

			while ((match = search.exec(query))) {
				urlParams[decode(match[1])] = decode(match[2]);
			}

			const currentBtag = getCookie("BTAGCOOKIE");
			const masterToken = getCookie("MT");
			const sessionToken = getCookie("ST");
			const currentReferrerBtag = getCookie("REFERRERBTAGCOOKIE");

			
			if (urlParams.btagoverride) {
				setWildCardCookie("BTAGCOOKIE", urlParams.btagoverride, 7);
				SetQueryStringParams();
				return
			}

			if (currentBtag === undefined || currentBtag === null || currentBtag.trim() === "") {
				getBannerTag(urlParams, currentBtag);
			} else if (currentReferrerBtag === undefined || currentReferrerBtag === null || currentReferrerBtag.trim() === "") {
				getReferrerBannerTag(urlParams, currentReferrerBtag);
			}
			let isNewToken = false;
			if (!masterToken || !sessionToken) {
				isNewToken = await getOriginToken(masterToken, sessionToken);
			}
			resolve(isNewToken);
		} catch (e) {
			reject(e);
		}
	});
}

function getOriginToken(masterToken: string | undefined, sessionToken: string | undefined) {
	return new Promise((resolve, reject) => {
		try {
			let isNewToken = false;
			const request = new XMLHttpRequest();
			request.open("GET", `${infoApi}/Origin/Tokens`);
			request.send();
			request.onload = function () {
				try {
					const res = JSON.parse(this.response);
					if (!masterToken) {
						setWildCardCookie("MT", res.MasterToken, 1825);
					}

					if (!sessionToken) {
						setWildCardCookie("ST", res.MasterToken, 0);
						resolve(true);
					}

					resolve(false);
				} catch (e) {
					reject(e);
				}
			};
		} catch (e) {
			reject(e);
		}
	});
}

function getBannerTag(urlParams: any, currentBtag: any) {
	try {
		const referrer = document.referrer.replace(/\?.*/gm, "") || window.location.origin;
		const request = new XMLHttpRequest();

		if (urlParams.btag && urlParams.btag.trim() === "") {
			urlParams.btag = undefined;
		}

		request.open("GET", `${infoApi}/Origin/BannerTag?request.referringUrl=${referrer}`);
		request.setRequestHeader("X-OT-Origin", window.location.origin);
		request.send();

		request.onload = function () {
			const res = JSON.parse(this.response);
			if (urlParams.btag && urlParams.btag !== undefined && !currentBtag) {
				setWildCardCookie("BTAGCOOKIE", urlParams.btag, 7);
				setWildCardCookie("REFERRERBTAGCOOKIE", urlParams.btag, 0);
			} else if (!currentBtag && !urlParams.btag) {
				setWildCardCookie("BTAGCOOKIE", res.BannerTagString, 7);
				setWildCardCookie("REFERRERBTAGCOOKIE", res.BannerTagString, 0);
			} else {
				setWildCardCookie("BTAGCOOKIE", "No Tag", 1);
				setWildCardCookie("REFERRERBTAGCOOKIE", "No Tag", 0);
			}
			SetQueryStringParams();
		};
	} catch (err: any) {
		setWildCardCookie("BTAGCOOKIE", err.message, 1);
		SetQueryStringParams();
	}
}

function getReferrerBannerTag(urlParams: any, currentReferrerBtag: any) {
	try {
		const referrer = document.referrer.replace(/\?.*/gm, "") || window.location.origin;
		const request = new XMLHttpRequest();

		if (urlParams.btag && urlParams.btag.trim() === "") {
			urlParams.btag = undefined;
		}
		request.open("GET", `${infoApi}/Origin/BannerTag?request.referringUrl=${referrer}`);
		request.setRequestHeader("X-OT-Origin", window.location.origin);
		request.send();

		request.onload = function () {
			const res = JSON.parse(this.response);
			if (urlParams.btag && urlParams.btag !== undefined && !currentReferrerBtag) {
				setWildCardCookie("REFERRERBTAGCOOKIE", urlParams.btag, 0);
			} else if (!currentReferrerBtag && !urlParams.btag) {
				setWildCardCookie("REFERRERBTAGCOOKIE", res.BannerTagString, 0);
			} else {
				setWildCardCookie("REFERRERBTAGCOOKIE", "No Tag", 0);
			}
		};
	} catch (err) {
		SetQueryStringParams();
	}
}

function SetQueryStringParams() {
	let websiteUrl = window.location.href;

	function removeURLParameter(url: string, parameter: any) {
		const urlparts = url.split("?");
		if (urlparts.length >= 2) {
			const prefix = encodeURIComponent(parameter) + "=";
			const pars = urlparts[1].split(/[&;]/g);
			for (let i = pars.length; i-- > 0; ) {
				if (pars[i].lastIndexOf(prefix, 0) !== -1) {
					pars.splice(i, 1);
				}
			}

			return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
		}
		return url;
	}

	websiteUrl = removeURLParameter(websiteUrl, "mobileNumber");
	websiteUrl = removeURLParameter(websiteUrl, "email");
	websiteUrl = removeURLParameter(websiteUrl, "firstName");
	websiteUrl = removeURLParameter(websiteUrl, "lastName");
	websiteUrl = removeURLParameter(websiteUrl, "MobileNumber");
	websiteUrl = removeURLParameter(websiteUrl, "Email");
	websiteUrl = removeURLParameter(websiteUrl, "FirstName");
	websiteUrl = removeURLParameter(websiteUrl, "LastName");
	const t = websiteUrl.split("?");
	t.length === 2 ? setWildCardCookie("OriginalQueryString", t[1], 7) : setWildCardCookie("OriginalQueryString", "/", 7);
}
